import { cleaningFeeReturnService } from '@/api/cleaning-fees.service';
import type { CleaningFeeDto, CleaningFeeSelectionDto } from '@carvia/ros-client-types';
import { useQuery, useMutation } from '@tanstack/vue-query';

// Get available cleaning fees
export function useAvailableCleaningFees() {
  return useQuery<CleaningFeeDto[]>({
    queryKey: ['cleaning-fees', 'available'],
    queryFn: () => cleaningFeeReturnService.getAvailableCleaningFees(),
  });
}

export function useAddCleaningFee(bookingId: string) {
  return useMutation({
    mutationKey: ['cleaning-fees', 'add'],
    mutationFn: (selection: CleaningFeeSelectionDto) =>
      cleaningFeeReturnService.addCleaningFeeToBooking(bookingId, selection),
    onMutate: () => ({
      successMessage: 'Cleaning fee added',
      invalidateQueryKeys: ['bookings', bookingId],
    }),
  });
}
